<div class="py-5 px-3 px-md-5 background-white">
  <div class="title">
    <h3>{{'homepage.direct-channel.journey.title' | translate}}</h3>
    <div>
      <h5>
        {{'homepage.direct-channel.journey.subtitle' | translate}}
        <button class="btn w-auto" (click)="infoJourneyModal.open()">
          <pwc-icon name="info"></pwc-icon>
        </button>
      </h5>
    </div>

    <div>
      <ol class="ProgressBar">
        @for (step of listOfStep; track step; let i = $index) {
<li class="ProgressBar-step" [ngClass]="{
          'is-current': isCurrent(step),
          'is-complete': isComplete(step)
        }">
            <div class="ProgressBar-icon col">
              @if (!isComplete(step)) {
                <span> {{step+1}} </span>
              }
              @if (isComplete(step)) {
                <img class="completed whiteIcon" src="/assets/images/icons/check.svg" />
              }
              <span class="tooltiptext" [class.first-item]="i==0" [class.last-item]="i==listOfStep.length-1">{{('homepage.direct-channel.journey.step.description-hover.' + step) |
              translate}}</span>
            </div>
            <!-- fix hint -->
            @if (isCurrent(step)) {
              <div class="hint shadow p-3 mb-1 bg-white hint-{{step}}">
                <b>{{'homepage.direct-channel.journey.step.title' |translate}} {{step+1}}</b>
                <br />
                {{('homepage.direct-channel.journey.step.description.' + step) |translate}}
              </div>
            }
            @if (step === nStep && isCurrent(step+1)) {
              <div class="hint shadow p-3 mb-1 bg-white hint-{{step}}">
                <b>{{'homepage.direct-channel.journey.step.title' |translate}} {{step+2}}</b>
                <br />
                {{('homepage.direct-channel.journey.step.description.' + (step+1)) |translate}}
              </div>
            }
          </li>
        }
      </ol>
    </div>
  </div>
</div>

<pwc-modal #infoJourneyModal [id]="'infoJourneyModal'" showFooter="false">
  <div modal-title class="pe-4">
    <h2>
      <b> {{'homepage.direct-channel.journey.step.recap-title' | translate}} </b>
    </h2>
  </div>
  <div modal-body>
    @for (step of listOfStep; track step; let i = $index) {
      <h4>
        <b>{{'homepage.direct-channel.journey.step.title'|translate}} {{i+1}}</b>
        {{('homepage.direct-channel.journey.step.description.' + i) |translate}}
      </h4>
    }
  </div>
</pwc-modal>
